import { useEffect, useState } from "react";
import { ArrowLeft, Plus, Receipt } from "lucide-react";
import { toast } from "sonner";
import { api, money } from "../api";
import { useAuth } from "../auth";
import QuickPaymentModal from "../components/QuickPaymentModal";

const StatusBadge = ({ s }) => <em className={`status ${s === "Bekliyor" ? "status-amber" : s === "Planlanan" ? "status-blue" : "status-green"}`}>{s}</em>;

export default function EmployerDetail({ id, onBack }) {
  const { can } = useAuth();
  const [data, setData] = useState(null);
  const [quick, setQuick] = useState(null);

  const load = () => api.get(`/employers/${id}/detail`).then((r) => setData(r.data)).catch(() => toast.error("İşveren detayı yüklenemedi"));
  useEffect(() => { load(); }, [id]);

  if (!data) return <main className="content"><p>Yükleniyor…</p></main>;
  const t = data.totals;

  return (
    <main className="content" data-testid="page-employer-detail">
      <button className="link-back" onClick={onBack} data-testid="employer-detail-back"><ArrowLeft size={14} /> İşverenlere dön</button>
      <div className="page-head">
        <div>
          <span className="section-kicker">İŞVEREN</span>
          <h1>{data.short_name}</h1>
          <p>{data.name}{data.tax_no ? ` · Vergi: ${data.tax_office || "—"} ${data.tax_no}` : ""}{data.contact_person ? ` · ${data.contact_person}` : ""}{data.phone ? ` · ${data.phone}` : ""}</p>
        </div>
        {can("admin", "project_manager", "finance") && (
          <button className="new-btn btn-green" onClick={() => setQuick({ direction: "incoming" })} data-testid="employer-detail-collect-button"><Plus size={15} /> Tahsilat Kaydet</button>
        )}
      </div>

      <div className="stats-grid">
        <div className="stat"><div><div className="eyebrow">Toplam Anlaşılan</div><strong>{money(t.total_agreed)}</strong><span className="stat-detail">{t.project_count} proje</span></div></div>
        <div className="stat"><div><div className="eyebrow">Tahsil Edilen</div><strong>{money(t.total_collected)}</strong><span className="stat-detail">İşverenden alınan</span></div></div>
        <div className="stat"><div><div className="eyebrow">Kalan Tahsilat</div><strong className="margin">{money(t.remaining)}</strong><span className="stat-detail">Bakiye</span></div></div>
        <div className="stat"><div><div className="eyebrow">Proje Sayısı</div><strong>{t.project_count}</strong><span className="stat-detail">Portföy</span></div></div>
      </div>

      {(data.totals_by_currency || []).length > 1 && (
        <section className="panel" data-testid="employer-currency-totals">
          <div className="panel-head"><div><span className="eyebrow">PARA BİRİMİ BAZINDA</span><h2>Döviz cinsine göre toplamlar</h2></div></div>
          <div className="project-table">
            <div className="table-row table-head cur-tot-row"><span>PARA BİRİMİ</span><span>PROJE</span><span>ANLAŞILAN</span><span>TAHSİLAT</span><span>KALAN</span></div>
            {data.totals_by_currency.map((c) => (
              <div className="table-row cur-tot-row" key={c.currency} data-testid={`employer-cur-${c.currency}`}>
                <b>{c.currency}</b>
                <span>{c.project_count}</span>
                <b className="mono-small">{money(c.agreed, c.currency)}</b>
                <span className="mono-small">{money(c.collected, c.currency)}</span>
                <b className="margin">{money(c.remaining, c.currency)}</b>
              </div>
            ))}
          </div>
        </section>
      )}

      {data.projects.map((g) => {
        const collectRatio = g.agreed_amount ? Math.min(100, Math.round((g.collected / g.agreed_amount) * 100)) : 0;
        return (
          <section className="panel" key={g.project_id} data-testid={`employer-detail-project-${g.project_name}`}>
            <div className="panel-head">
              <div>
                <span className="eyebrow">PROJE #{g.project_no || "-"} · {g.status || ""}</span>
                <h2>{g.project_name}</h2>
              </div>
              <b className="mono-small">Anlaşılan {money(g.agreed_amount, g.currency)} · Tahsilat {money(g.collected, g.currency)} · <span className="margin">Kalan {money(g.remaining, g.currency)}</span></b>
            </div>
            <div className="progress" style={{ marginBottom: 14 }}><i style={{ width: `${collectRatio}%` }} /></div>

            {g.payments.length > 0 ? (
              <>
                <div className="wi-detail-head">
                  <span className="eyebrow"><Receipt size={12} style={{ verticalAlign: "-2px", marginRight: 4 }} />TAHSİLAT DÖKÜMÜ ({g.payments.length})</span>
                </div>
                {g.payments.map((p) => (
                  <div className="mini-pay" key={p.id} data-testid={`employer-payment-${p.id}`}>
                    <span>{p.stage}</span>
                    <span>{p.date ? p.date.slice(0, 10) : "—"}</span>
                    <span>{p.due_date ? `vade ${p.due_date.slice(0, 10)}` : ""}</span>
                    <b className="mono-small">{money(p.amount, p.currency)}</b>
                    <StatusBadge s={p.status} />
                    <small>{p.description || ""}</small>
                  </div>
                ))}
              </>
            ) : (
              <div className="empty-hint small">Bu proje için tahsilat kaydı yok.</div>
            )}
          </section>
        );
      })}
      {!data.projects.length && <div className="empty-hint">Bu işverene bağlı proje yok.</div>}

      {quick && <QuickPaymentModal preset={quick} close={() => setQuick(null)} onSaved={load} />}
    </main>
  );
}
